import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lineTypeMappingChange'
})
export class LineTypeMappingChangePipe implements PipeTransform {

  transform(value: any, args?: any): any {
      let str = value.line_type;
      if(value.line_type.length > 0){
          return value.line_type;
      }

      return 'Both';
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/beeztel-codes/pipes/line-type-mapping-change.pipe.ts